module.exports = __webpack_public_path__ + "static/imgs/title-h.b4cadf2.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/title-h.png
// module id = LvBT
// module chunks = 1